import { render, staticRenderFns } from "./AccountLoginModal.vue?vue&type=template&id=4b822089"
import script from "./AccountLoginModal.vue?vue&type=script&lang=js"
export * from "./AccountLoginModal.vue?vue&type=script&lang=js"
import style0 from "./AccountLoginModal.vue?vue&type=style&index=0&id=4b822089&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports